import { VACATION_PAYMENT_PERCENT, type VacationType } from '@czas/shared'

import { cn } from '@/lib/cn'

export default function PaymentBadge({
  type,
  className,
}: {
  type: VacationType
  className?: string
}) {
  const pct = VACATION_PAYMENT_PERCENT[type]
  const tone =
    pct === 100
      ? 'text-success bg-success/10 border-success/30'
      : pct === 80
        ? 'text-warning bg-warning/10 border-warning/30'
        : 'text-text-faint bg-text-faint/10 border-border-subtle'

  return (
    <span
      className={cn(
        'inline-flex items-center text-[10px] font-medium px-2 py-0.5 rounded-full border',
        tone,
        className,
      )}
      title={`Wynagrodzenie: ${pct}% (orientacyjnie)`}
    >
      {pct}%
    </span>
  )
}
